import { formatLogMetadataError, formatProfitLabel, getShortTransactionLogId } from '@smarttransit/common'

export default {
  name: 'agent-transaction-details-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      default: null
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeLabel () {
      const iconData = this.transaction && this.transaction.logTypeIconData
      return (iconData && iconData.label) || 'Transaction'
    },
    statusLabel () {
      return (this.transaction && this.transaction.logStatusLabel) || ''
    },
    conversionRateLabel () {
      return (this.transaction && this.transaction.conversionRatePercentLabel) || ''
    },
    profitLabel () {
      const transaction = this.transaction
      if (!transaction) {
        return ''
      }
      return formatProfitLabel(
        transaction.logType,
        transaction.amount,
        transaction.conversionRatePercent,
        transaction.currencyPrefix || ''
      )
    },
    customerTransactionIdLabel () {
      const referenceId = this.transaction && this.transaction.transactionLogReferenceId
      return referenceId ? getShortTransactionLogId(referenceId) : ''
    },
    errorLabel () {
      return formatLogMetadataError(this.transaction && this.transaction.logMetadata)
    },
    hasAccount () {
      const transaction = this.transaction
      return !!(transaction && (transaction.passengerPhoneNumberLabel || transaction.phoneNumberLabel))
    },
    hasBalance () {
      const transaction = this.transaction
      return !!(transaction && (transaction.profileBalanceBeforeLabel || transaction.profileBalanceAfterLabel))
    }
  },
  methods: {
    closeDialog () {
      this.dialogModel = false
    }
  }
}
